import React, { useEffect } from 'react';
import { useAdminContext } from '../../contexts/admin_context';

const PrivateRoute = ({ children }) => {
  const { isAdmin, isLoading } = useAdminContext();

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      window.location.href = '/login';
    }
  }, [isLoading, isAdmin]);

  if (isLoading) {
    return null; // or a loading spinner
  }

  if (!isAdmin) {
    return null;
  }

  return children;
};

export default PrivateRoute;
